import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import MeetSelect from './nav/MeetSelect';
import Loader from './nav/Loader';

import { connect } from "react-redux";
import { getImpactDiffData } from "../actions/action_impactdiff";
import { setMeetFilter } from "../actions/action_impactdiff";

class ImpactDiff extends Component {
  constructor(props) {
      let columns = [
        {Header: 'First', accessor: 'fname', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.props.yearFilter+'/'+this.props.teamFilter+'/'+props.original.gid}>{props.value}</a>},
        {Header: 'Last', accessor: 'lname', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.props.yearFilter+'/'+this.props.teamFilter+'/'+props.original.gid}>{props.value}</a>},
        {Header: 'FX', accessor: 'fx', width: 70},
        {Header: 'Diff', accessor: 'fxDiff', width: 70, className: "difference-chart-bgcolor", headerClassName: "difference-chart-bgcolor"},
        {Header: 'PH', accessor: 'ph', width: 70},
        {Header: 'Diff', accessor: 'phDiff', width: 70, className: "difference-chart-bgcolor", headerClassName: "difference-chart-bgcolor"},
        {Header: 'SR', accessor: 'sr', width: 70},
        {Header: 'Diff', accessor: 'srDiff', width: 70, className: "difference-chart-bgcolor", headerClassName: "difference-chart-bgcolor"},
        {Header: 'VT', accessor: 'vt', width: 70},
        {Header: 'Diff', accessor: 'vtDiff', width: 70, className: "difference-chart-bgcolor", headerClassName: "difference-chart-bgcolor"},
        {Header: 'PB', accessor: 'pb', width: 70},
        {Header: 'Diff', accessor: 'pbDiff', width: 70, className: "difference-chart-bgcolor", headerClassName: "difference-chart-bgcolor"},
        {Header: 'HB', accessor: 'hb', width: 70},
        {Header: 'Diff', accessor: 'hbDiff', width: 70, className: "difference-chart-bgcolor", headerClassName: "difference-chart-bgcolor"},
        {Header: 'AA', accessor: 'aa', width: 70},
        {Header: 'Total Diff', accessor: 'aaDiff', width: 70, className: "difference-chart-bgcolor", headerClassName: "difference-chart-bgcolor"},
      ];
      super(props);
      this.state = {
        cols: columns
      };
      this.handleMeetChange = this.handleMeetChange.bind(this);
      this.getMeetSelectBox = this.getMeetSelectBox.bind(this);
      this.getTable = this.getTable.bind(this);
  }
  componentDidMount() {
    let meetnum = 0;
    if(this.props.meets[0] !== undefined) {
      meetnum = this.props.meets[0].meet_id;
    }
    this.props.getImpactDiffData({
      "year": this.props.yearFilter,
      "team": this.props.teamFilter,
      "meet": meetnum
    });
  }
  componentDidUpdate(prevProps) {
    if(prevProps.meets !== this.props.meets) {
      var meet = this.props.meets[0] === undefined ? 0 : this.props.meets[0].meet_id;
      this.props.getImpactDiffData({
        "year": this.props.yearFilter,
        "team": this.props.teamFilter,
        "meet": meet
      });
    }
  }
  handleMeetChange(event) {
    this.props.getImpactDiffData({
      "year": this.props.yearFilter,
      "team": this.props.teamFilter,
      "meet": Number(event.currentTarget.value)
    });
    this.props.setMeetFilter(Number(event.currentTarget.value));
  }
  getMeetSelectBox() {
    //if(this.props.meetFilter !== 0) {
      return <div className="row" >
        <div className="small-12 columns">
          <MeetSelect meets={this.props.meets} meetFilter={this.props.meetFilter} handleMeetChange={this.handleMeetChange}/>
        </div>
      </div>;
    //}
  }
  getTable() {
    if(!this.props.showLoader) {
      if(this.props.teamFilter > 0) {
        return <div className="small-12 columns">
          <div className="row" >
            <div className="small-12 columns">
              {this.getMeetSelectBox()}
            </div>
          </div>
          <div className="row expanded" >
          <div className="small-12 columns">
            <ReactTable
              data={this.props.data}
              columns={this.state.cols}
              defaultSortMethod={this.defaultSortMethod}
              showPagination={false}
              defaultPageSize={this.props.numRows}
              pageSize={this.props.numRows}
            /><br />
            <p className="note">*This chart works by subtracting the lowest score on every event from all the other scores on that event. This gives an idea of what impact a gymnast would have if she were removed from the meet for some reason. Like most tables on this site, the results can be sorted by clicking on the column titles.</p>
          </div>
        </div>
      </div>;
      } else {
        return <div>Please Pick a Team</div>
      }
    } else {
      return <Loader />;
    }
  }
  defaultSortMethod(a, b) { //desc
    // force null and undefined to the bottom
    a = (a === null || a === undefined) ? -Infinity : a
    b = (b === null || b === undefined) ? -Infinity : b
    // force any string values to lowercase
    a = a === 'string' ? a.toLowerCase() : a
    b = b === 'string' ? b.toLowerCase() : b
    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return -1
    }
    if (a < b) {
      return 1
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
    return 0
  }
  render() {
    return (
      <div>
          <div className="row expanded">
            {this.getTable()}
          </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    teamFilter: state.main.teamFilter,
    yearFilter: state.main.yearFilter,
    data: state.impactDiff.data,
    numRows: state.impactDiff.numRows,
    meetFilter: state.impactDiff.meetFilter,
    showLoader: state.impactDiff.showLoader
  };
}

export default connect(mapStateToProps, { getImpactDiffData, setMeetFilter })(ImpactDiff);
